(function () {
  const items = document.querySelectorAll('[data-ppt-mega-item]');
  if (!items.length) return;

  items.forEach((item) => {
    const trigger = item.querySelector('[data-ppt-mega-trigger]');
    const panel = item.querySelector('[data-ppt-mega-panel]');
    if (!trigger || !panel) return;

    const isDismissed = () => item.classList.contains('is-dismissed');
    const setExpanded = (value) => trigger.setAttribute('aria-expanded', String(value));

    item.addEventListener('mouseenter', () => {
      item.classList.remove('is-dismissed');
      setExpanded(true);
    });

    item.addEventListener('focusin', () => {
      if (isDismissed()) return;
      setExpanded(true);
    });

    item.addEventListener('mouseleave', () => {
      if (item.contains(document.activeElement)) return;
      item.classList.remove('is-dismissed');
      setExpanded(false);
    });

    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget)) return;
      item.classList.remove('is-dismissed');
      setExpanded(false);
    });

    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      item.classList.add('is-dismissed');
      setExpanded(false);
      trigger.focus();
    });
  });
})();
